import { UtilizationTag } from "@/types";
import type { KeywordRanking } from "@/types";
import { matchesPrioritySearchPhrase } from "@/components/keyword-bank/utils";
import { parseTermList } from "@/components/keyword-bank/keywordBankClient";

// AUT-472: Filters-panel state of the landscape output that the bank also has.
export interface LandscapeFilterState {
  /** checkbox groups: source, utilization, masterList */
  checkbox: Record<string, string[]>;
  /** raw comma-separated text: phrases, exclude */
  text: Record<string, string>;
  /** phrasesMode: "any" | "all" */
  matchModes: Record<string, string>;
}

export const DEFAULT_LANDSCAPE_FILTER_STATE: LandscapeFilterState = {
  checkbox: { source: [], utilization: [], masterList: [] },
  text: { phrases: "", exclude: "" },
  matchModes: { phrasesMode: "any" },
};

export function keywordPassesLandscapeFilters(
  kw: KeywordRanking,
  state: LandscapeFilterState,
  prioritySearchPhrase: string | null | undefined,
): boolean {
  const text = kw.keyword.toLowerCase();

  const phrases = parseTermList(state.text.phrases);
  if (phrases.length > 0) {
    const ok = state.matchModes.phrasesMode === "all"
      ? phrases.every((t) => text.includes(t))
      : phrases.some((t) => text.includes(t));
    if (!ok) return false;
  }

  const excluded = parseTermList(state.text.exclude);
  if (excluded.some((t) => text.includes(t))) return false;

  if ((state.checkbox.masterList ?? []).length > 0 && !kw.is_master_list) return false;

  const sources = state.checkbox.source ?? [];
  if (sources.length > 0) {
    const own: string[] = kw.sources ?? [];
    if (!sources.some((s) => own.includes(s))) return false;
  }

  const utilization = state.checkbox.utilization ?? [];
  if (utilization.length > 0) {
    const own: string[] = (kw.utilization ?? []).filter(
      (u) => u !== UtilizationTag.LANDSCAPED || matchesPrioritySearchPhrase(kw.keyword, prioritySearchPhrase),
    );
    if (!utilization.some((u) => own.includes(u))) return false;
  }

  return true;
}
